import { render, staticRenderFns } from "./Autenticate.vue?vue&type=template&id=2b6d43fb&scoped=true&lang=pug&"
import script from "./Autenticate.vue?vue&type=script&lang=js&"
export * from "./Autenticate.vue?vue&type=script&lang=js&"
import style0 from "./Autenticate.vue?vue&type=style&index=0&id=2b6d43fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d43fb",
  null
  
)

export default component.exports